
{
  "global": {
    "Tokens": {
      "Main": {
        "main-01": {
          "value": "#62616C",
          "type": "color"
        },
        "main-02": {
          "value": "#43424D",
          "type": "color"
        },
        "main-03": {
          "value": "#E3E3E9",
          "type": "color"
        },
        "main-04": {
          "value": "#3378F6",
          "type": "color"
        },
        "main-05": {
          "value": "#ffffff",
          "type": "color"
        },
        "main-06": {
          "value": "#292735",
          "type": "color"
        }
      },
      "Diamonds": {
        "diam-01": {
          "value": "#804195",
          "type": "color"
        },
        "diam-02": {
          "value": "#713782",
          "type": "color"
        },
        "diam-03": {
          "value": "#EEE1F3",
          "type": "color"
        },
        "diam-04": {
          "value": "#9138AE",
          "type": "color"
        },
        "diam-05": {
          "value": "#ffffff",
          "type": "color"
        },
        "diam-06": {
          "value": "#9138AE",
          "type": "color"
        }
      },
      "Core": {
        "core-01": {
          "value": "#ffffff",
          "type": "color"
        },
        "core-02": {
          "value": "#F4F4F7",
          "type": "color"
        },
        "core-03": {
          "value": "#DEDEE3",
          "type": "color"
        },
        "core-04": {
          "value": "#B8B8BF",
          "type": "color"
        },
        "core-05": {
          "value": "#020001",
          "type": "color"
        },
        "core-06": {
          "value": "#62616C",
          "type": "color"
        }
      },
      "Extra": {
        "extra-01": {
          "value": "#A1A0AB",
          "type": "color"
        },
        "extra-02": {
          "value": "#878690",
          "type": "color"
        },
        "extra-03": {
          "value": "#ECECF2",
          "type": "color"
        },
        "extra-04": {
          "value": "#DADAE0",
          "type": "color"
        },
        "extra-05": {
          "value": "#ffffff",
          "type": "color"
        },
        "extra-06": {
          "value": "#62616C",
          "type": "color"
        }
      },
      "Gemstones": {
        "gem-01": {
          "value": "#3B72CC",
          "type": "color"
        },
        "gem-02": {
          "value": "#3C62A0",
          "type": "color"
        },
        "gem-03": {
          "value": "#DCE6F6",
          "type": "color"
        },
        "gem-04": {
          "value": "#3E76D2",
          "type": "color"
        },
        "gem-05": {
          "value": "#ffffff",
          "type": "color"
        },
        "gem-06": {
          "value": "#3E76D2",
          "type": "color"
        }
      },
      "Jewelry": {
        "jewelry-01": {
          "value": "#58B8A5",
          "type": "color"
        },
        "jewelry-02": {
          "value": "#4CA191",
          "type": "color"
        },
        "jewelry-03": {
          "value": "#D6F1ED",
          "type": "color"
        },
        "jewelry-04": {
          "value": "#27AC92",
          "type": "color"
        },
        "jewelry-05": {
          "value": "#ffffff",
          "type": "color"
        },
        "jewelry-06": {
          "value": "#27AC92",
          "type": "color"
        }
      },
      "Lab-Grown": {
        "lab-01": {
          "value": "#E97F5B",
          "type": "color"
        },
        "lab-02": {
          "value": "#DA704B",
          "type": "color"
        },
        "lab-03": {
          "value": "#F9E2D9",
          "type": "color"
        },
        "lab-04": {
          "value": "#E87B56",
          "type": "color"
        },
        "lab-05": {
          "value": "#ffffff",
          "type": "color"
        },
        "lab-06": {
          "value": "#E87B56",
          "type": "color"
        }
      },
      "Overlay": {
        "over-01": {
          "value": "#000000b3",
          "type": "color"
        },
        "over-02": {
          "value": "rgba(55,54,64,0.3)",
          "type": "color"
        },
        "over-03": {
          "value": "rgba(255,255,255,0.7)",
          "type": "color"
        },
        "over-04": {
          "value": "#ffffff",
          "type": "color"
        }
      },
      "Signal": {
        "cont-00": {
          "value": "#ffffff",
          "type": "color"
        },
        "success-02": {
          "value": "#DBFFE4",
          "type": "color"
        },
        "success-01": {
          "value": "#00B140",
          "type": "color"
        },
        "error-02": {
          "value": "#FFE9E8",
          "type": "color"
        },
        "error-01": {
          "value": "#D0021B",
          "type": "color"
        },
        "warn-02": {
          "value": "#FFF8DB",
          "type": "color"
        },
        "warn-01": {
          "value": "#FFA500",
          "type": "color"
        }
      }
    },
    "Action": {
      "primary-bg-static": {
        "value": "{Tokens.Main.main-01}",
        "type": "color"
      },
      "primary-bg-hover": {
        "value": "{Tokens.Main.main-02}",
        "type": "color"
      },
      "primary-bg-disabled": {
        "value": "{Tokens.Core.core-03}",
        "type": "color"
      },
      "primary-cont": {
        "value": "{Tokens.Main.main-05}",
        "type": "color"
      },
      "primary-cont-disabled": {
        "value": "{Tokens.Core.core-04}",
        "type": "color"
      },
      "secondary-bor-disabled": {
        "value": "{Tokens.Core.core-03}",
        "type": "color"
      },
      "secondary-cont-disabled": {
        "value": "{Tokens.Core.core-04}",
        "type": "color"
      },
      "secondary-bg-hover": {
        "value": "{Tokens.Main.main-03}",
        "type": "color"
      },
      "secondary-bor-hover": {
        "value": "{Tokens.Main.main-02}",
        "type": "color"
      },
      "secondary-bor-static": {
        "value": "{Tokens.Main.main-01}",
        "type": "color"
      },
      "secondary-cont": {
        "value": "{Tokens.Main.main-06}",
        "type": "color"
      },
      "tertiary-bg-static": {
        "value": "{Tokens.Main.main-03}",
        "type": "color"
      },
      "tertiary-bg-disabled": {
        "value": "{Tokens.Core.core-03}",
        "type": "color"
      },
      "tertiary-cont": {
        "value": "{Tokens.Main.main-06}",
        "type": "color"
      },
      "tertiary-cont-disabled": {
        "value": "{Tokens.Core.core-04}",
        "type": "color"
      },
      "link-static": {
        "value": "{Tokens.Main.main-04}",
        "type": "color"
      },
      "link-hover": {
        "value": "{Tokens.Main.main-06}",
        "type": "color"
      }
    },
    "fontFamilies": {
      "roboto": {
        "value": "Roboto",
        "type": "fontFamilies"
      }
    },
    "lineHeights": {
      "0": {
        "value": "32",
        "type": "lineHeights"
      },
      "1": {
        "value": "24",
        "type": "lineHeights"
      },
      "2": {
        "value": "20",
        "type": "lineHeights"
      },
      "3": {
        "value": "136%",
        "type": "lineHeights"
      },
      "4": {
        "value": "16",
        "type": "lineHeights"
      }
    },
    "fontWeights": {
      "roboto-0": {
        "value": "SemiBold",
        "type": "fontWeights"
      },
      "roboto-1": {
        "value": "Medium",
        "type": "fontWeights"
      },
      "roboto-2": {
        "value": "Bold",
        "type": "fontWeights"
      },
      "roboto-3": {
        "value": "Regular",
        "type": "fontWeights"
      }
    },
    "fontSize": {
      "0": {
        "value": "12",
        "type": "fontSizes"
      },
      "1": {
        "value": "14",
        "type": "fontSizes"
      },
      "2": {
        "value": "16",
        "type": "fontSizes"
      },
      "3": {
        "value": "17",
        "type": "fontSizes"
      },
      "4": {
        "value": "18",
        "type": "fontSizes"
      },
      "5": {
        "value": "21",
        "type": "fontSizes"
      },
      "6": {
        "value": "24",
        "type": "fontSizes"
      },
      "7": {
        "value": "24",
        "type": "fontSizes"
      }
    },
    "letterSpacing": {
      "0": {
        "value": "0",
        "type": "letterSpacing"
      },
      "1": {
        "value": "1",
        "type": "letterSpacing"
      }
    },
    "paragraphSpacing": {
      "0": {
        "value": "0",
        "type": "paragraphSpacing"
      }
    },
    "Mobile": {
      "Large-B": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-0}",
          "lineHeight": "{lineHeights.0}",
          "fontSize": "{fontSize.6}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "Lead-M": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-1}",
          "lineHeight": "{lineHeights.0}",
          "fontSize": "{fontSize.5}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "H1-B": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-2}",
          "lineHeight": "{lineHeights.1}",
          "fontSize": "{fontSize.4}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "H2-M": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-1}",
          "lineHeight": "{lineHeights.1}",
          "fontSize": "{fontSize.3}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "H2-R": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-3}",
          "lineHeight": "{lineHeights.1}",
          "fontSize": "{fontSize.3}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "H3-M": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-1}",
          "lineHeight": "{lineHeights.1}",
          "fontSize": "{fontSize.2}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "H3-R": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-3}",
          "lineHeight": "{lineHeights.1}",
          "fontSize": "{fontSize.2}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "Body-M": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-1}",
          "lineHeight": "{lineHeights.2}",
          "fontSize": "{fontSize.1}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "Body-SB": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-3}",
          "lineHeight": "{lineHeights.2}",
          "fontSize": "{fontSize.1}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "Minor-M": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-1}",
          "lineHeight": "{lineHeights.3}",
          "fontSize": "{fontSize.0}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "Minor-R": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-3}",
          "lineHeight": "{lineHeights.3}",
          "fontSize": "{fontSize.0}",
          "letterSpacing": "{letterSpacing.0}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.none}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      }
    },
    "textCase": {
      "none": {
        "value": "none",
        "type": "textCase"
      },
      "uppercase": {
        "value": "uppercase",
        "type": "textCase"
      }
    },
    "textDecoration": {
      "none": {
        "value": "none",
        "type": "textDecoration"
      }
    },
    "paragraphIndent": {
      "0": {
        "value": "0px",
        "type": "dimension"
      }
    },
    "Option": {
      "option-bg-static": {
        "value": "{Tokens.Extra.extra-03}",
        "type": "color"
      },
      "option-bg-hover": {
        "value": "{Tokens.Extra.extra-04}",
        "type": "color"
      },
      "option-bg-active": {
        "value": "{Tokens.Extra.extra-01}",
        "type": "color"
      },
      "option-cont": {
        "value": "{Tokens.Extra.extra-06}",
        "type": "color"
      },
      "option-cont-active": {
        "value": "{Tokens.Extra.extra-05}",
        "type": "color"
      },
      "knob-bg-hover": {
        "value": "{Tokens.Extra.extra-03}",
        "type": "color"
      },
      "knob-bg-active": {
        "value": "{Tokens.Extra.extra-02}",
        "type": "color"
      },
      "knob-cont": {
        "value": "{Tokens.Extra.extra-05}",
        "type": "color"
      },
      "knob-bor": {
        "value": "{Tokens.Extra.extra-02}",
        "type": "color"
      },
      "toggle-bg-static": {
        "value": "{Tokens.Extra.extra-04}",
        "type": "color"
      },
      "toggle-bg-on": {
        "value": "{Tokens.Extra.extra-02}",
        "type": "color"
      },
      "toggle-cont": {
        "value": "{Tokens.Extra.extra-05}",
        "type": "color"
      },
      "option-bg-disabled": {
        "value": "{Tokens.Core.core-03}",
        "type": "color"
      },
      "option-cont-disabled": {
        "value": "{Tokens.Core.core-04}",
        "type": "color"
      },
      "knob-bg-disabled-off": {
        "value": "{Tokens.Core.core-02}",
        "type": "color"
      },
      "knob-bg-disabled-on": {
        "value": "{Tokens.Core.core-03}",
        "type": "color"
      },
      "knob-cont-disabled-on": {
        "value": "{Tokens.Core.core-01}",
        "type": "color"
      },
      "toggle-bg-disabled": {
        "value": "{Tokens.Core.core-03}",
        "type": "color"
      },
      "toggle-cont-disabled": {
        "value": "{Tokens.Core.core-02}",
        "type": "color"
      }
    },
    "Smooth": {
      "value": "16px",
      "type": "borderRadius"
    },
    "Generic": {
      "value": "8px",
      "type": "borderRadius"
    },
    "Minor": {
      "value": "4px",
      "type": "borderRadius"
    },
    "Shadows": {
      "Huge": {
        "value": {
          "color": "#37364066",
          "type": "dropShadow",
          "x": 2,
          "y": 16,
          "blur": 32,
          "spread": -8
        },
        "type": "boxShadow"
      },
      "Normal": {
        "value": {
          "color": "#37364042",
          "type": "dropShadow",
          "x": 2,
          "y": 8,
          "blur": 24,
          "spread": -6
        },
        "type": "boxShadow"
      },
      "Gentle": {
        "value": {
          "color": "#37364014",
          "type": "dropShadow",
          "x": 1,
          "y": 2,
          "blur": 4,
          "spread": -2
        },
        "type": "boxShadow"
      },
      "Bottom-scroll": {
        "value": {
          "color": "#37364029",
          "type": "dropShadow",
          "x": 0,
          "y": -8,
          "blur": 24,
          "spread": -8
        },
        "type": "boxShadow"
      }
    },
    "Web": {
      "NAV-R": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-3}",
          "lineHeight": "{lineHeights.4}",
          "fontSize": "{fontSize.1}",
          "letterSpacing": "{letterSpacing.1}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.uppercase}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      },
      "NAV-M": {
        "value": {
          "fontFamily": "{fontFamilies.roboto}",
          "fontWeight": "{fontWeights.roboto-1}",
          "lineHeight": "{lineHeights.4}",
          "fontSize": "{fontSize.1}",
          "letterSpacing": "{letterSpacing.1}",
          "paragraphSpacing": "{paragraphSpacing.0}",
          "paragraphIndent": "{paragraphIndent.0}",
          "textCase": "{textCase.uppercase}",
          "textDecoration": "{textDecoration.none}"
        },
        "type": "typography"
      }
    }
  },
  "$themes": [],
  "$metadata": {
    "tokenSetOrder": [
      "global"
    ]
  }
}
